<template>
	<div class="lottery_periods">
		<h3>
			<span>开奖信息</span>
			<router-link class="history" :to="{ name: 'historyLottery', query: { id: $route.query.id } }" target="_blank">
				更多
			</router-link>
		</h3>
		<div class="lottery_periods_content" v-if="id === 18 || id === 21">
			<el-row>
				<el-col :span="8">期号</el-col>
				<el-col :span="16">开奖号码</el-col>
			</el-row>
			<el-row v-for="(item, index) in LastFiveLssue" :key="index" class="lottery_periods_item">
				<el-col :span="8">
					<div class="grid-content">{{ item.FormatLssue }}</div>
				</el-col>
				<el-col :span="16">
					<div class="grid-content">
						<span v-for="(value, num) in item.OpenNumber" :key="num">{{ value }}</span>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="lottery_periods_content" v-else-if="id === 0">
			<el-row>
				<el-col :span="10">期号</el-col>
				<el-col :span="14">开奖号码</el-col>
			</el-row>
			<el-row v-for="(item, index) in LastFiveLssue" :key="index" class="lottery_periods_item">
				<el-col :span="10">
					<div class="grid-content">{{ item.FormatLssue }}</div>
				</el-col>
				<el-col :span="14">
					<div class="ks">
						<span
							:class="[
								value == 1
									? 'one'
									: value == 2
									? 'two'
									: value == 3
									? 'three'
									: value == 4
									? 'four'
									: value == 5
									? 'five'
									: 'six',
							]"
							v-for="(value, num) in item.OpenNumber.split(',')"
							:key="num"
						></span>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="lottery_periods_content" v-else-if="id === 9">
			<el-row>
				<el-col :span="4">期号</el-col>
				<el-col :span="20">开奖号码</el-col>
			</el-row>
			<el-row v-for="(item, index) in LastFiveLssue" :key="index" class="lottery_periods_item sc_periods_item">
				<el-col :span="4">
					<div class="grid-content">{{ item.FormatLssue }}</div>
				</el-col>
				<el-col :span="20" class="pkcalss">
					<div class="grid-content sc_style">
						<span v-for="(value, num) in item.neeArr" :key="num" :class="value.text">{{ value.name }}</span>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="lottery_periods_content" v-else-if="id === 19">
			<el-row>
				<el-col :span="8">期号</el-col>
				<el-col :span="16">开奖号码</el-col>
			</el-row>
			<el-row v-for="(item, index) in LastFiveLssue" :key="index" class="lottery_periods_item">
				<el-col :span="8">
					<div class="grid-content">{{ item.FormatLssue }}</div>
				</el-col>
				<el-col :span="16">
					<div class="grid-content">
						<template v-for="(value, num) in item.OpenNumber">
							<span :class="`xinyun-item ${isNaN(value) ? 'item-symbol' : 'item-number'}`" :key="num">{{ value }}</span>
						</template>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="lottery_periods_content" v-else-if="index === 7">
			<el-row>
				<el-col :span="10">期号</el-col>
				<el-col :span="14">开奖号码</el-col>
			</el-row>
			<el-row v-for="(item, index) in LastFiveLssue" :key="index" class="lottery_lhc_item">
				<el-col :span="24">
					<div class="lhc_content" style="line-height: 24px">{{ item.FormatLssue }}</div>
					<div class="lhc_content lhc_content_2">
						<div class="lhc_content_item">
							<div :class="[returnClass(item.OpenNumber.split(',')[0])]">
								{{ item.OpenNumber.split(",")[0] }}
							</div>
							<div v-if="item.Explain != null">{{ item.Explain.split("")[0] }}</div>
						</div>
						<span>+</span>
						<div class="lhc_content_item">
							<div :class="[returnClass(item.OpenNumber.split(',')[1])]">
								{{ item.OpenNumber.split(",")[1] }}
							</div>
							<div v-if="item.Explain != null">{{ item.Explain.split("")[1] }}</div>
						</div>
						<span>+</span>
						<div class="lhc_content_item">
							<div :class="[returnClass(item.OpenNumber.split(',')[2])]">
								{{ item.OpenNumber.split(",")[2] }}
							</div>
							<div v-if="item.Explain != null">{{ item.Explain.split("")[2] }}</div>
						</div>
						<span>+</span>
						<div class="lhc_content_item">
							<div :class="[returnClass(item.OpenNumber.split(',')[3])]">
								{{ item.OpenNumber.split(",")[3] }}
							</div>
							<div v-if="item.Explain != null">{{ item.Explain.split("")[3] }}</div>
						</div>
						<span>+</span>
						<div class="lhc_content_item">
							<div :class="[returnClass(item.OpenNumber.split(',')[4])]">
								{{ item.OpenNumber.split(",")[4] }}
							</div>
							<div v-if="item.Explain != null">{{ item.Explain.split("")[4] }}</div>
						</div>
						<span>+</span>
						<div class="lhc_content_item">
							<div :class="[returnClass(item.OpenNumber.split(',')[5])]">
								{{ item.OpenNumber.split(",")[5] }}
							</div>
							<div v-if="item.Explain != null">{{ item.Explain.split("")[5] }}</div>
						</div>
						<span>+</span>
						<div class="lhc_content_item">
							<div :class="[returnClass(item.OpenNumber.split(',')[6])]">
								{{ item.OpenNumber.split(",")[6] }}
							</div>
							<div v-if="item.Explain != null">{{ item.Explain.split("")[6] }}</div>
						</div>
						<span>=</span><strong>{{ sumArray(item.OpenNumber.split(",")) }}</strong>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="lottery_periods_content" v-else-if="index === 1">
			<el-row>
				<el-col :span="10">期号</el-col>
				<el-col :span="14">开奖号码</el-col>
			</el-row>
			<el-row
				v-for="(item, index) in LastFiveLssue"
				:key="index"
				class="lottery_periods_item"
				:class="[returnSscClass()]"
			>
				<el-col :span="10">
					<div class="grid-content">{{ item.FormatLssue }}</div>
				</el-col>
				<el-col :span="14">
					<div class="grid-content">
						<span v-for="(value, num) in item.OpenNumber.split(',')" :key="num">{{ value }}</span>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="lottery_periods_content" v-else>
			<el-row>
				<el-col :span="10">期号</el-col>
				<el-col :span="14">开奖号码</el-col>
			</el-row>
			<el-row v-for="(item, index) in LastFiveLssue" :key="index" class="lottery_periods_item">
				<el-col :span="10">
					<div class="grid-content">{{ item.FormatLssue }}</div>
				</el-col>
				<el-col :span="14">
					<div class="grid-content" style="margin-right: 5px">
						<span v-for="(value, num) in item.OpenNumber.split(',')" :key="num">{{ value }}</span>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import { arraySum } from "../../util/common";

export default {
	name: "history",
	props: {
		historyData: {
			type: Array,
			required: true,
		},
		id: {
			type: Number,
			required: false,
		},
		styleId: {
			//0五星1四星2前三3中三4后三5二星0定位胆0不定位0任四任三任二
			type: Number,
			required: false,
		},
	},
	data() {
		return {
			LastFiveLssue: [], //近五期开奖数据
			allLotterydata: [], //全部开奖数据
			lotteryButton: "更多历史开奖", //更多历史开奖按钮
			pkgame: [], //pk10数据处理
			index: parseInt(this.$route.query.index),
		};
	},
	watch: {
		historyData(val) {
			if (this.id === 9) {
				this.allLotterydata = val.map((item, index) => {
					let newObj = Object.assign({}, item);
					let arr = {
						"01": "one",
						"02": "two",
						"03": "three",
						"04": "four",
						"05": "five",
						"06": "six",
						"07": "seven",
						"08": "eight",
						"09": "nine",
						10: "ten",
					};
					let num = item.OpenNumber.split(",");
					let str = item.FormatLssue.split("-");
					if (item.FormatLssue.indexOf("-") > -1) {
						newObj.FormatLssue = str[1];
					} else {
						newObj.FormatLssue = str[0];
						if (str[0].length > 6) {
							newObj.FormatLssue = str[0].substring(5);
						} else {
							newObj.FormatLssue = str[0];
						}
					}
					newObj.neeArr = [];
					num.forEach(val => {
						newObj.neeArr.push({
							name: val,
							text: arr[val],
						});
					});
					return newObj;
				});
				this.LastFiveLssue = this.allLotterydata.slice(0, 50);
				return false;
			}
			this.allLotterydata = val;
			if (this.index === 7) {
				this.LastFiveLssue = val.slice(0, 9);
			} else {
				this.LastFiveLssue = val.slice(0, 18);
			}
		},
	},
	methods: {
		//筛选返回时时彩历史记录样式
		returnSscClass() {
			//0五星1后四星2前三3中三4后三5后二星0定位胆0不定位0任四任三任二6龙虎7前四8前二
			let styleArr = [
				"all_sty",
				"four_str",
				"front_three",
				"center_three",
				"after_three",
				"two_sty",
				"long_hu",
				"before_four",
				"before_two",
			];
			return styleArr[this.styleId];
		},
		//返回球的颜色
		returnClass(str) {
			let num = Number(str);
			if ([1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46].includes(num)) {
				return "red_qiu";
			}
			if ([3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48].includes(num)) {
				return "blue_qiu";
			}
			if ([5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49].includes(num)) {
				return "green_qiu";
			}
		},
		sumArray(arr) {
			return arraySum(arr);
		},
	},
};
</script>

<style lang="scss" scoped>
.lottery_periods {
	width: 342px;
	height: 100%;
	text-align: center;

	h3 {
		position: relative;
		z-index: 2;
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 50px;
		line-height: 50px;
		font-size: 14px;
		font-weight: normal;
		color: #555;
		padding-left: 12px;
		box-shadow: 0px 3px 3px 0 rgba(0, 0, 0, 0.15);
		background-image: linear-gradient(to top, #f0f0f0 22%, #f1f1f1, #fff);
		> span {
			vertical-align: middle;
			&::before {
				content: "";
				display: inline-block;
				width: 24px;
				height: 24px;
				vertical-align: middle;
				margin-right: 5px;
				background: url(../../static/img/lhc/Trophy.webp) no-repeat;
				background-size: 100%;
			}
		}

		a {
			position: relative;
			line-height: 50px;
			font-size: 14px;
			width: 70px;
			color: #555;
			color: #333333;
			box-shadow: inset 3px 0 6px 0 rgba(0, 0, 0, 0.15);
			background-image: linear-gradient(to top, #f0f0f0, #e3e6e8, #f0f0f0);
			&:after {
				content: ">";
				color: #ccc;
			}
		}
	}

	.lottery_periods_title {
		height: 30px;
		line-height: 30px;
		margin-bottom: 1px;
		background-color: #ececec;
		text-align: center;
		color: #000;
		box-shadow: 0 1px 1px 0 #ffffff;
		border-bottom: solid 1px #ddd8d4;
	}

	.lottery_periods_content {
		position: relative;
		width: 100%;
		height: calc(100% - 50px);
		background-color: #ffffff;
		overflow-y: auto;
		overflow-x: hidden;

		& > .el-row {
			line-height: 40px;
			font-size: 14px;
			font-weight: 400;
			color: #555;
			font-family: PingFangSC;
		}

		& > div:first-child {
			position: sticky;
			top: 0;
			z-index: 1;
			// background-image: linear-gradient(to top, #f0f0f0 22%, #e3e6e8, #f0f0f0);
			background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);

			color: #fff;
		}

		.lottery_periods_item {
			height: 40px;
			line-height: 40px;
			text-align: center;
			display: flex;
			align-items: center;
			.xinyun-item.item-symbol {
				border: 0;
			}

			&:nth-child(odd) {
				background: #eee;
			}
			&:nth-child(even) {
				.grid-content {
					color: #888;
				}
			}

			div:first-child {
				// font-family: Arial;
				font-size: 14px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #555;
			}

			div:last-child {
				display: flex;
				justify-content: center;
				align-items: center;
				height: 36px;

				span {
					display: inline-block;
					width: 26px;
					height: 26px;
					line-height: 28px;
					margin: 0 2px;
					font-size: 18px;
					letter-spacing: 0;
					color: #0e78c7;
					border-radius: 100%;
					// font-family: Arial;
					font-weight: bold;
					text-align: center;
				}
			}

			.xinyun-item:nth-of-type(even) {
				width: auto !important;
				font-size: 18px !important;
				color: #888 !important;
				font-weight: normal;
			}

			.ks {
				span {
					width: 24px !important;
					height: 24px !important;
					border-radius: 0 !important;
					background-color: transparent !important;
					background-position: center center;
					background-size: cover;
				}
			}
		}

		.lottery_lhc_item {
			text-align: left;
			background: #fff;
			position: sticky;
			top: 40px;
			padding-right: 5px;
			&:nth-child(odd) {
				background: #fafafa;
			}

			.lhc_content {
				display: flex;
				justify-content: space-between;
				font-size: 13px;
				color: #555;

				&:first-child {
					padding: 8px 0 0 7px;
				}

				&:last-child {
					padding: 0 0 8px 7px;
				}

				span {
					margin: 0 2px;
					color: #1483d1 !important;
					font-size: 20px;
					line-height: 22px;
					background: none !important;
					margin-top: 3px;
				}

				strong {
					color: #1483d1;
					line-height: 22px;
					font-size: 16px;
					// font-weight: 600;
					font-weight: 400;
					margin-top: 4px;
				}

				.lhc_content_item {
					width: 24px;
					display: flex;
					flex-direction: column;
					align-items: center;

					div {
						width: 21px;

						&:first-child {
							width: 30px;
							height: 30px;
							font-size: 18px;
							color: #ffffff;
							font-family: Acre;
							display: flex;
							align-items: center;
							justify-content: center;
							background-position: 0 1px;
						}

						&:last-child {
							margin-top: 2px;
							font-size: 12px;
							line-height: 16px;
							text-align: center;
							color: #1483d1;
							// font-weight: 600;
							font-weight: 400;
						}
					}
				}
			}
		}
	}

	.sc_periods_item {
		display: flex;
		align-items: center;
	}

	a {
		display: inline-block;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 1px;
		line-height: 50px;
		color: #9b9b9b;
		cursor: pointer;
	}
}

.pkcalss {
	display: block !important;

	.sc_style {
		width: 100%;
		display: block;
		flex-wrap: wrap;

		span {
			display: inline-block;
			width: 24px !important;
			height: 24px !important;
			margin: 0 2px 0 0 !important;
			line-height: 25px !important;
			font-size: 13px !important;
			color: #ffffff !important;
			background-repeat: no-repeat;
			background-position: center center;
			background-size: 100% 100%;
			border-radius: 50%;
			&.one {
				background-image: linear-gradient(to top, #fccc65, #fbbe3c);
			}
			&.two {
				background-image: linear-gradient(to top, #6ab3f0, #499ee5);
			}
			&.three {
				background-image: linear-gradient(to top, #949393, #6c6c6c);
			}
			&.four {
				background-image: linear-gradient(to top, #f89b50, #ee8129);
			}
			&.five {
				background-image: linear-gradient(to top, #69e7f6, #47d2e2);
			}
			&.six {
				background-image: linear-gradient(to top, #6c8df4, #4a6fe5);
			}
			&.seven {
				background-image: linear-gradient(to top, #bfbfbf, #a5a4a4);
			}
			&.eight {
				background-image: linear-gradient(to top, #f4786b, #e55849);
			}
			&.nine {
				background-image: linear-gradient(to top, #af4e44, #993a30);
			}
			&.ten {
				background-image: linear-gradient(to top, #8ddc6a, #7bcb58);
			}
		}
	}
}

.lottery_periods_content span.one {
	background-image: url(../../static/img/icon/touzi_Draw1.webp);
}

.lottery_periods_content span.two {
	background-image: url(../../static/img/icon/touzi_Draw2.webp);
}

.lottery_periods_content span.three {
	background-image: url(../../static/img/icon/touzi_Draw3.webp);
}

.lottery_periods_content span.four {
	background-image: url(../../static/img/icon/touzi_Draw4.webp);
}

.lottery_periods_content span.five {
	background-image: url(../../static/img/icon/touzi_Draw5.webp);
}

.lottery_periods_content span.six {
	background-image: url(../../static/img/icon/touzi_Draw6.webp);
}

//各游戏玩法的开奖样式
//默认样式
.all_sty {
	&:nth-child(2),
	&:hover {
		div:first-child {
			color: #d86556 !important;
			transition: all 0.3s;
		}

		div:last-child {
			span {
				color: #fff !important;
				transition: all 0.3s;
				background-color: #0e78c7 !important;
			}
		}
	}
}
//前三
.front_three {
	&:nth-child(2),
	&:hover {
		div:first-child {
			color: #d86556 !important;
			transition: all 0.3s;
		}

		div:last-child {
			span {
				color: #fff;
				transition: all 0.3s;

				&:nth-child(-n + 3) {
					color: #fff;
					transition: all 0.3s;
					background-color: #2794e7;
				}

				&:nth-child(n + 4) {
					color: #fff !important;
					background-color: #b1b1b1;
				}
			}
		}
	}

	div:last-child {
		span {
			&:nth-child(-n + 3) {
				color: #c19f62;
				background-color: transparent;
			}

			&:nth-child(n + 4) {
				color: #b1b1b1 !important;
			}
		}
	}
}

//中三
.center_three {
	&:nth-child(2),
	&:hover {
		div:first-child {
			color: #d86556 !important;
			transition: all 0.3s;
		}

		div:last-child {
			span {
				color: #fff;
				transition: all 0.3s;

				&:nth-child(2),
				&:nth-child(3),
				&:nth-child(4) {
					color: #fff;
					transition: all 0.3s;
					background-color: #2794e7;
				}

				&:first-child,
				&:last-child {
					color: #fff !important;
					background-color: #b1b1b1;
				}
			}
		}
	}

	div:last-child {
		span {
			&:nth-child(2),
			&:nth-child(3),
			&:nth-child(4) {
				color: #c19f62;
				background-color: transparent;
			}

			&:first-child,
			&:last-child {
				color: #b1b1b1 !important;
			}
		}
	}
}

//后三
.after_three {
	span {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	&:nth-child(2),
	&:hover {
		div:first-child {
			color: #e9537a !important;
			transition: all 0.3s;
			font-family: Arial;
			font-size: 12px;
			text-align: center;
		}

		div:last-child {
			span {
				color: #fff;
				transition: all 0.3s;

				&:nth-child(n + 3) {
					color: #fff;
					width: 26px;
					height: 26px;
					line-height: 28px;
					transition: all 0.3s;
					background-color: #2794e7;
					font-size: 18px;
					font-family: Arial;
					font-weight: bold;
				}

				&:nth-child(-n + 2) {
					color: #fff !important;
					width: 26px;
					height: 26px;
					line-height: 28px;
					background-color: #aaaaaa;
					font-size: 18px;
					font-family: Arial;
					font-weight: bold;
				}
			}
		}
	}

	div:last-child {
		span {
			&:nth-child(n + 3) {
				color: #c19f62;
				background-color: transparent;
			}

			&:nth-child(-n + 2) {
				color: #aaa !important;
			}
		}
	}
}

//前二
.before_two {
	&:nth-child(2),
	&:hover {
		div:first-child {
			color: #d86556 !important;
			transition: all 0.3s;
		}

		div:last-child {
			span {
				color: #fff;
				transition: all 0.3s;

				&:nth-child(-n + 2) {
					color: #fff;
					transition: all 0.3s;
					background-color: #2794e7;
				}

				&:nth-child(n + 3) {
					color: #fff !important;
					background-color: #b1b1b1;
				}
			}
		}
	}

	div:last-child {
		span {
			&:nth-child(-n + 2) {
				color: #c19f62;
				background-color: transparent;
			}

			&:nth-child(n + 3) {
				color: #b1b1b1 !important;
			}
		}
	}
}

//后二
.two_sty {
	&:nth-child(2),
	&:hover {
		div:first-child {
			color: #d86556 !important;
			transition: all 0.3s;
		}

		div:last-child {
			span {
				color: #fff;
				transition: all 0.3s;

				&:nth-child(n + 3) {
					color: #fff;
					transition: all 0.3s;
					background-color: #2794e7;
				}

				&:nth-child(-n + 3) {
					color: #fff !important;
					background-color: #b1b1b1;
				}
			}
		}
	}

	div:last-child {
		span {
			&:nth-child(n + 3) {
				color: #c19f62;
				background-color: transparent;
			}

			&:nth-child(-n + 3) {
				color: #b1b1b1 !important;
			}
		}
	}
}

//前四
.before_four {
	&:nth-child(2),
	&:hover {
		div:first-child {
			color: #d86556 !important;
			transition: all 0.3s;
		}

		div:last-child {
			span {
				color: #fff;
				transition: all 0.3s;

				&:nth-child(-n + 5) {
					color: #fff;
					transition: all 0.3s;
					background-color: #2794e7;
				}

				&:last-child {
					color: #fff !important;
					background-color: #b1b1b1;
				}
			}
		}
	}

	div:last-child {
		span {
			&:nth-child(-n + 5) {
				color: #c19f62;
				background-color: transparent;
			}

			&:last-child {
				color: #b1b1b1 !important;
			}
		}
	}
}

//后四
.four_str {
	&:nth-child(2),
	&:hover {
		div:first-child {
			color: #d86556 !important;
			transition: all 0.3s;
		}

		div:last-child {
			span {
				color: #fff;
				transition: all 0.3s;

				&:nth-child(n + 2) {
					color: #fff;
					transition: all 0.3s;
					background-color: #2794e7;
				}

				&:first-child {
					color: #fff !important;
					background-color: #b1b1b1;
				}
			}
		}
	}

	div:last-child {
		span {
			&:nth-child(n + 2) {
				color: #c19f62;
				background-color: transparent;
			}

			&:first-child {
				color: #b1b1b1 !important;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/history.vue